type ProjectConfigType = {
  VITE_API_BASE_URL: string
  VITE_GOOGLE_CLIENT_ID: string
  VITE_APP_VERSION: string
}

const projectConfig: Record<keyof ProjectConfigType, string> = {
  VITE_API_BASE_URL: '${VITE_API_BASE_URL}',
  VITE_GOOGLE_CLIENT_ID: '${VITE_GOOGLE_CLIENT_ID}',
  VITE_APP_VERSION: '${VITE_APP_VERSION}',
}

const DEFAULTS: Partial<Record<keyof ProjectConfigType, string | number>> = {
  VITE_API_BASE_URL: 'http://localhost:8080',
  VITE_APP_VERSION: 'dev',
}

function resolveStringEnvVar (key: keyof ProjectConfigType): string {
  const value = projectConfig[key]
  const fromEnv = import.meta.env[key]
  // if the value is still under template form (ie "contains VITE"), we use the value from import.meta.env
  // otherwise we take the value from project vars
  const resolved = value.includes('VITE_') ? fromEnv : value
  // apply default value if nothing is found, or empty if not present
  return resolved ?? (DEFAULTS[key] as string) ?? ''
}

function resolveNumberEnvVar (key: keyof ProjectConfigType): number {
  const stringValue = resolveStringEnvVar(key)
  const parsed = Number(stringValue)
  if (Number.isNaN(parsed)) {
    const fallback = DEFAULTS[key]
    if (typeof fallback === 'number') {
      return fallback
    }
    throw new Error(`Env variable ${key} is not a valid number and no valid default is provided.`)
  }
  return parsed
}

let cachedConfig: ProjectConfigType | null = null

export function getProjectConfig (): ProjectConfigType {
  if (cachedConfig) {
    return cachedConfig
  }

  cachedConfig = {
    VITE_API_BASE_URL: resolveStringEnvVar('VITE_API_BASE_URL'),
    VITE_GOOGLE_CLIENT_ID: resolveStringEnvVar('VITE_GOOGLE_CLIENT_ID'),
    VITE_APP_VERSION: resolveStringEnvVar('VITE_APP_VERSION'),
  }
  return cachedConfig
}
